// @core/api/endpoints/authn/end_oidc_session.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  EndOIDCSessionRequest,
  EndOIDCSessionResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * End OIDC session (logout)
 * Ends the OIDC session and optionally redirects to a post-logout URI. Implements the OIDC RP-Initiated Logout specification for single logout across applications.
 * @public This endpoint does not require authentication
 */
export async function EndOIDCSession(
  data: EndOIDCSessionRequest,
  options?: RequestOptions
): Promise<EndOIDCSessionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oidc/session/end`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<EndOIDCSessionResponse>(requestPath, data, requestOptions);
}
